import { EOoklaMeasurementNames, TOoklaMeasurementNames } from '@constants/ookla';

export const getOoklaMeasurementType = (measurement: string): TOoklaMeasurementNames | null => {
	if (measurement.startsWith(EOoklaMeasurementNames.RSRP)) {
		return EOoklaMeasurementNames.RSRP;
	}

	if (measurement.startsWith(EOoklaMeasurementNames.RSRQ)) {
		return EOoklaMeasurementNames.RSRQ;
	}

	return null;
};
